import { inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { localeId, matLocaleId } from '@config';
import { provideCepBrowserEnvironment } from '@libs/features/cep';
import { RouteHistoryService } from '@libs/shared/services';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';

@NgModule({
  imports: [AppModule],
  bootstrap: [AppComponent],
  providers: [
    provideAppInitializer(() => void inject(RouteHistoryService)),
    provideCepBrowserEnvironment(environment),
    {
      provide: LOCALE_ID,
      useValue: localeId,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: matLocaleId,
    },
  ],
})
export class AppBrowserModule {
}
